import { Component, OnInit, ViewChild} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FormService } from '../form/form.service';
import { FormPreviewService } from '../form-preview/form-preview.service';
import { MatDialog } from '@angular/material/dialog';
import * as _ from 'lodash';
import { Lightbox } from 'ngx-lightbox';
import { PdfViewerModalComponent } from "../pdf-viewer-modal/pdf-viewer-modal.component";
import { PasswordModalComponent } from '../password-modal/password-modal.component';
import { DomSanitizer } from '@angular/platform-browser';
import { AsYouType, parsePhoneNumber } from 'libphonenumber-js'
import $ from 'jquery';
import { SharedService } from '../services/shared.service';
import { Constants } from '../Constants';
import { MatSelect } from '@angular/material/select';


interface Food {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {

  toppings = new FormControl();
  editable: Boolean = true;
  bgTextColor = "#000000";

  successsOpen() {
    this.successMsg = true;
  };
  toppingList: string[] = ['Extra cheese', 'Mushroom', 'Onion', 'Pepperoni', 'Sausage', 'Tomato']
  foods: Food[] = [
    { value: 'steak-0', viewValue: 'Steak' },
    { value: 'pizza-1', viewValue: 'Pizza' },
    { value: 'tacos-2', viewValue: 'Tacos' }
  ];
  templateId;
  formName;
  template;
  updatedAt;
  organization;
  organizationId;
  formResponse = {};
  subTopicsData = [];
  successMsg = false;
  saveValidity = true;

  sortId = localStorage.getItem("organizationCode") || "";
  userEmail = localStorage.getItem("email") || "";
  userName = (localStorage.getItem("firstName") || "") + " " + (localStorage.getItem("lastName") || "");

  constructor(
    private activatedRoute: ActivatedRoute,
    private _formService: FormService,
    private _router: Router,
    private _formPreviewService: FormPreviewService,
    private _lightbox: Lightbox,
    public dialog: MatDialog,
    private _domSanitizer: DomSanitizer,
    private _sharedService: SharedService
  ) { }

  ngOnInit(): void {
    this.onInit();
  }

  onInit(): void {
    this.formResponse = {};
		this.subTopicsData = [];
    if (localStorage.getItem('bgTextColor')) this.bgTextColor = localStorage.getItem("bgTextColor");
    // this.activatedRoute.queryParams.subscribe((params) => {
      let params = {
        id : '609411fd30b8054f604249b9',
        editable : 'true'
      }
      if (params["id"]) {
        this.templateId = params["id"];
        this._formService.getTemplateById(params["id"]).subscribe((response) => {
          if (response['success']) {
            this.formName = response["data"][0]["name"];
            this.template = response["data"][0]["template_schema"]["schema"];
            this.updatedAt = response["data"][0]["updated_at"];
            this.organization = response["data"][0]["organization"];
			this.organizationId = response["data"][0]["organization"]["_id"];
            if (response["data"][0]["auth_required"]) {
              this.openEnterPasswordDialog();
            }
			for(let element of this.template) {
				switch(element.type) {
					case "email":
						element.value = this.userEmail;
						this.formResponse[element.key] = this.userEmail;
						break;
					case "text":
						if(element.key === "what_is_your_s_o_r_t_i_d__44") {
							element.value = this.sortId;
							this.formResponse[element.key] = this.sortId;
						}
						if(element.key === "employeename") {
							element.value = this.userName;
							this.formResponse[element.key] = this.userName;
						}
						break;
				}
			}
          }
        });
      }

      if (params["editable"] === "false") {
        this.editable = false;
      }
    // });
  }

  onInsurance(event, element) {
    if (event.target.files && event.target.files[0] && element["type"] === 'picture') {

			if(!Constants.acceptedImageTypes.includes(event.target.files[0].type)) {
				element.error = "Invalid image format. Please upload only JPEG, PNG, WEBP images.";
				return;
			}
			if (!element['value']) element['value'] = [];	
			if (!element['picture_files']) element['picture_files'] = [];
			var filesAmount = event.target.files.length;
			let filesLength = element['picture_files'].length + filesAmount;
			if (filesLength > 5 || filesAmount > 5) {
				let templateIndex = this.template.findIndex((field) => field.key === element.key);
				this.template[templateIndex].error = "Only five picture uploads are allowed per field";
				return;
			}
			for (let i = 0; i < filesAmount; i++) {
				if (event.target.files[i]["size"] > 5000000) {
					let templateIndex = this.template.findIndex((field) => field.key === element.key);
					this.template[templateIndex].error = "Image size cannot exceed 5MB";
					return;
				}
			}

			for (let i = 0; i < filesAmount; i++) {
				var reader = new FileReader();
				reader.onload = (event: any) => {
					if (element.type === 'picture') {
						let image = event.target.result;
						element['value'].push({ src: image, thumb: image});
					}
				}
				reader.readAsDataURL(event.target.files[i]);
				element['picture_files'].push(event.target.files[i]);
			}
		}
		if (event.target.files && event.target.files[0] && element["type"] === 'file') {
			if(!Constants.acceptedFileTypes.includes(event.target.files[0].type)) {
				element.error = "Invalid file type. Only PDF is allowed.";
				return;
			}
			if (!element['value']) element['value'] = [];
			if (!element['picture_files']) element['picture_files'] = [];
			if (!element['raw_images']) element['raw_images'] = [];
			var filesAmount = event.target.files.length;
			let filesLength = element['picture_files'].length + filesAmount;
			if (filesLength > 5 || filesAmount > 5) {
				let templateIndex = this.template.findIndex((field) => field.key === element.key);
				this.template[templateIndex].error = "Only five file uploads are allowed per field";
				return;
			}

			for (let i = 0; i < filesAmount; i++) {
				if (event.target.files[i]["size"] > 5000000) {
					let templateIndex = this.template.findIndex((field) => field.key === element.key);
					this.template[templateIndex].error = "File size cannot exceed 5MB";
					return;
				}
			}

			for (let i = 0; i < filesAmount; i++) {
				var reader = new FileReader();
				reader.onload = (event: any) => {
					let image = event.target.result.split(',')[1];
					element['raw_images'].push(this._domSanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(new Blob([new Uint8Array(atob(image).split('').map(char => char.charCodeAt(0)))], { type: 'application/pdf'}))));
				}
				reader.readAsDataURL(event.target.files[i]);
				element['picture_files'].push(event.target.files[i]);
			}
		}
		let templateIndex = this.template.findIndex((field) => field.key === element.key);
		this.template[templateIndex]["error"] = "";
		const input = document.getElementById(element.key);
		input["value"] = null;
  }

  deletePicture(element, index) {
		element['value'].splice(index, 1);
		element['picture_files'].splice(index, 1);
		this.template[index]["error"] = "";
	}

  open(index: number, images): void {
    // open lightbox
    this._lightbox.open(images, index);
  }

  close(): void {
    // close lightbox programmatically
    this._lightbox.close();
  }

  deleteFile(element, index) {
		element['value'].splice(index, 1);
		element['picture_files'].splice(index, 1);
		this.template[index]["error"] = "";
	}

  onCancel() {
    this.onInit();
  }

  getHostName() {
    return document.location.protocol + '//' + document.location.hostname + '/';
  }

  getSubTopics() {
    const subTopicsFieldData = this.template.find(c => c.key === 'subtopic');
    return subTopicsFieldData.dependent_data[this.formResponse['topic']];
  }

  getValue(element) {
    if (this.formResponse && this.formResponse[element.key] && element.key !== 'topic') {
      const selectedItem = element.data.find(c => c.label === element.value);
      return selectedItem;
    } else if (element.key === 'topic') {
      const selectedItem = element.data.find(c => c.label === this.formResponse['topic']);
      if (selectedItem) return selectedItem;
    } else if (element.key === 'subtopic') {
      return this.subTopicsData;
    }
    return element.data[1];
  }

  onFieldChange(key, value, type) {

    if (type === 'question' || type === 'checkbox') {
			if (value === 'true') value = true;
			if (value === 'false') value = false;
		}
		if (type === 'select') {
			var selectData = {};
			selectData[value.value] = value.label;
			value = selectData;
		}
		if (type === "contact") {
			let index = this.template.findIndex((element) => element.key === key);
			let obj = {
				email: "",
				phone: "",
				checked : false
			}
			this.formResponse[key] = obj;
			if (value === "yes") {
				this.template[index]["data"]["checked"] = true;
			} else {
				this.template[index]["data"]["checked"] = false;
				this.template[index]["data"]["email"] = "";
				this.template[index]["data"]["phone"] = "";
				this.formResponse[key]["email"] = "";
				this.formResponse[key]["phone"] = "";
			}
			value = {
				requested: this.template[index]["data"]["checked"],
				email: "",
				phone: ""
			}
		}

		this.formResponse[key] = value;
		let templateIndex = this.template.findIndex((element) => element.key === key);
		this.template[templateIndex]["error"] = "";

		if (key === 'topic') {
			const subTopicsFieldData = this.template.find(c => c.key === 'subtopic');
			const topicId = String((Object.keys(this.formResponse['topic']))[0]);
			this.subTopicsData = [];
			this.subTopicsData = subTopicsFieldData.dependent_data[topicId];
			let subtopicIndex = this.template.findIndex((element) => element.key === "subtopic");
			this.template[subtopicIndex]["error"] = "";
			if (this.formResponse["subtopic"]) {
				delete this.formResponse["subtopic"]; // Deleting subtopic selection
			}
		}
  }

  onSave() {

    let validity = true;
			var formData: FormData = new FormData();
			let topicsExist = true;
			let attachements = {}
			this.template.forEach(element => {
				if (element.value && element.picture_files) {
					if (!this.formResponse[element.key]) {
						this.formResponse[element.key] = [];
					}
					
					attachements[element.key]= []
					_.forEach(element.picture_files, (image, index) => {
						const file: File = image;
						const fileName = element.key + '_' + index;
						if (!_.includes(attachements[element.key], fileName)) {
							// this.formResponse[element.key].push(fileName);
							formData.append(fileName, file);
							attachements[element.key].push(fileName)
						}
					});
				}
				if (element.key === 'employeename') {
					if (!this.formResponse[element.key] || this.formResponse[element.key].length  === 0) {
						this.openResubmitToast();
						element.error = "This is a mandatory field";
						validity = false;
						return false;
					}
				} else if (element.key === "topic") {
					if (element.data.length === 0) {
						topicsExist = false;
						return false;
					}
					if (!this.formResponse[element.key] || this.formResponse[element.key].length  === 0) {
						this.openResubmitToast();
						element.error = "This is a mandatory field";
						validity = false;
						return false;
					}
				} else if (element.key === "subtopic") {
					if (topicsExist) {
						let topic = "";
						if (!this.formResponse["topic"]) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
						if (this.formResponse["topic"] && Object.keys(this.formResponse["topic"])[0]) {
							topic= Object.keys(this.formResponse["topic"])[0];
						}
						if (element.dependent_data) {
							let subtopics = element.dependent_data[topic];
							if (subtopics.length > 0) {
								if (!this.formResponse[element.key] || this.formResponse[element.key].length  === 0) {
									this.openResubmitToast();
									element.error = "This is a mandatory field";
									validity = false;
									return false;
								}
							}
						}
					}
				} else if (element.key === "subject") {
					if (!this.formResponse[element.key] || this.formResponse[element.key].length  === 0) {
						this.openResubmitToast();
						element.error = "This is a mandatory field";
						validity = false;
						return false;
					}
				} else if (element.type === "text" && element.visible) {
					if (element.validate.required) {
						if (!this.formResponse[element.key] || this.formResponse[element.key].length === 0) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
					// if (this.formResponse[element.key] && this.formResponse[element.key].length < element.validate.minlength) {
					// 	element.error = "This field should contain more than 1 character";
					// 	validity = false;
					// 	return false;
					// }
					if (this.formResponse[element.key] && this.formResponse[element.key].length > element.validate.maxlength) {
						this.openResubmitToast();
						element.error = element.validate && element.validate.maxlength ? "This field should not contain more than "+ element.validate.maxlength +" characters" : "This field should not contain more than 50 characters";
						validity = false;
						return false;
					}
				} else if (element.type === "textarea" && element.visible) {
					if (element.validate.required) {
						if (!this.formResponse[element.key] || this.formResponse[element.key].length === 0) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
					if (this.formResponse[element.key] && this.formResponse[element.key].length > element.validate.maxlength) {
						this.openResubmitToast();
						element.error = "This field should not contain more than 350 characters";
						validity = false;
						return false;
					}
				} else if (element.type === "email" && element.visible) {
					if (element.validate.required) {
						if (!this.formResponse[element.key] || this.formResponse[element.key].length === 0) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
					if (this.formResponse[element.key]) {
						let email = this.formResponse[element.key];
						let regex = /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-zA-Z]{2,4}$/;
						if (!regex.test(email)) {
							element.error = "Enter valid email address"
							validity = false;
							return false;
						}
					}
				} else if (element.type === "phone" && element.visible) {
					if (element.validate.required) {
						if (!this.formResponse[element.key] || this.formResponse[element.key].length === 0) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
					if (this.formResponse[element.key]) {
						let phone = parsePhoneNumber(this.formResponse[element.key], "US");
						let nationalNumber = phone.formatNational();
						let regex = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
						if (!regex.test(nationalNumber)) {
							element.error = "Enter valid phone number"
							validity = false;
							return false;
						} else {
							let phone = parsePhoneNumber(this.formResponse[element.key], "US");
							this.formResponse[element.key] = phone.number;
						}
					}
				} else if (element.type === "radio" && element.visible) {
					if (element.validate.required) {
						if (!this.formResponse[element.key]) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
				} else if (element.type === "checkbox" && element.visible) {

					if (!(element.key in this.formResponse)) {
						if (element.defaultValue) {
							this.formResponse[element.key] = element.defaultValue;
						}
					}

					if (element.validate.required) {
						if (!(element.key in this.formResponse)) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
				} else if (element.type === "select" && element.key !== "subtopic" && element.visible) {
					if (element.validate.required) {
						if (!(element.key in this.formResponse)) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
				} else if (element.type === "picture" && element.visible) {
					if (element.validate.required) {
						if (!(element.key in this.formResponse)) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
				} else if (element.type === "file" && element.visible) {
					if (element.validate.required) {
						if (!(element.key in this.formResponse)) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
				} else if (element.type === "question" && element.visible) {
					if (element.validate.required) {
						if (!(element.key in this.formResponse)) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
				} else if (element.type === "contact" && element.visible) {
					if (element.validate.required) {
						if (!(element.key in this.formResponse)) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
					if (element.key in this.formResponse) {
						if (this.formResponse[element.key].requested) {
							if (this.formResponse[element.key].email.length === 0) {
								let templateIndex = this.template.findIndex((field) => field.key === element.key);
								this.template[templateIndex]["data"]["emailError"] = "Enter valid email address";
								validity = false;
								this.openResubmitToast();
								// return false;
							} else {
								let templateIndex = this.template.findIndex((field) => field.key === element.key);
								let emailRegex = /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-zA-Z]{2,4}$/;
								let valid = emailRegex.test(String(this.formResponse[element.key].email).toLowerCase());
								if(!valid) {
									this.template[templateIndex]["data"]["emailError"] = "Enter valid email address";
									validity = false;
									this.openResubmitToast();
									// return false;
								}
							}
							if (this.formResponse[element.key].phone.length === 0) {
								let templateIndex = this.template.findIndex((field) => field.key === element.key);
								this.template[templateIndex]["data"]["phoneError"] = "Enter valid phone number";
								validity = false;
								this.openResubmitToast();
								// return false;
							} else {
								let templateIndex = this.template.findIndex((field) => field.key === element.key);
								try {
									let phone = parsePhoneNumber(this.formResponse[element.key].phone, "US");
									const re = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
									let nationalNumber = phone.formatNational();
									let valid = re.test(nationalNumber);
									if(!valid) {
										this.template[templateIndex]["data"]["phoneError"] = "Enter valid phone number";
										validity = false;
										this.openResubmitToast();
										// return false;
									}	
								} catch (error) {
									this.template[templateIndex]["data"]["phoneError"] = "Enter valid phone number";
									validity = false;
									this.openResubmitToast();
								}
							}
						}
					}
				} else if(element.type == "address" && element.visible) {
					// if (element.validate.required) {
					// 	if (!(element.key in this.formResponse)) {
					// 		this.openResubmitToast();
					// 		element.error = "This is a mandatory field";
					// 		validity = false;
					// 		return false;
					// 	}
					// }
					let templateIndex = this.template.findIndex((field) => field.key === element.key);
					if(element.validate.required) {
						
						if(!(element.key in this.formResponse) || !this.formResponse[element.key]['address'] || this.formResponse[element.key]['address'].length == 0) {
							this.template[templateIndex]["data"]['addressError'] = "Enter valid Street Address";
							validity = false;
							this.openResubmitToast();
							// return false;
						} 
						if(!(element.key in this.formResponse) || !this.formResponse[element.key]['city'] || this.formResponse[element.key]['city'].length == 0) {
							this.template[templateIndex]["data"]['cityError'] = "Enter valid City name"
							validity = false;
							this.openResubmitToast();
							// return false;
						} 
						if(!(element.key in this.formResponse) || !this.formResponse[element.key]['state'] || this.formResponse[element.key]['state'].length == 0) {
							this.template[templateIndex]["data"]['stateError'] = "Enter valid State name"
							validity = false;
							this.openResubmitToast();
							// return false;
						}
						if(!(element.key in this.formResponse) || !this.formResponse[element.key]['zipcode'] || this.formResponse[element.key]['zipcode'].length == 0) {
							this.template[templateIndex]["data"]['zipcodeError'] = "Enter valid Zip"
							validity = false;
							this.openResubmitToast();
							// return false;
						}
					}
					if(element.key in this.formResponse) {
						if(this.formResponse[element.key]['zipcode'] && this.formResponse[element.key]['zipcode'].length == 0) {
							this.template[templateIndex]["data"]['zipcodeError'] = "Enter valid Zip"
							validity = false;
							this.openResubmitToast();
							// return false;
						} else if(this.formResponse[element.key]['zipcode']) {
							let zipCodeValidator = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
							if(!zipCodeValidator.test(this.formResponse[element.key]['zipcode'])) {
								this.template[templateIndex]["data"]['zipcodeError'] = "Enter valid Zip"
								validity = false;
								this.openResubmitToast();
							}
						}
					}
							
				} else if (element.type === "date" && element.visible) {
					if (element.validate.required) {
						if (!(element.key in this.formResponse)) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
				} else if (element.type === "time" && element.visible) {
					if (element.validate.required) {
						if (!(element.key in this.formResponse)) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
				}
			});
			

			if (validity) {
				if(attachements && Object.keys(attachements).length > 0) {
					Object.keys(attachements).forEach(key => {
						this.formResponse[key] = attachements[key]
					})
				}
				var formResponseData = {
					response: this.formResponse,
					name: this.formName,
					organization: this.organizationId,
					updated_at: Date.now(),
					topic: this.formResponse['topic'],
					subtopic: this.formResponse['subtopic'],
					submittedBy: this.formResponse['employeename'],
					templateId: this.templateId,
					updated_by: { 
						username:localStorage.getItem('username'),
						user_id: localStorage.getItem('userId'),
						organization_id: localStorage.getItem('organization')
					},
					created_by: { 
						username:localStorage.getItem('username'),
						user_id: localStorage.getItem('userId'),
						organization_id: localStorage.getItem('organization')
					}
					// template_version: this.templateVersion
				}
				formData.append('formResponse', JSON.stringify(formResponseData));

				this._formPreviewService.submitFormDetails(formData, true).subscribe(
					(response) => {
						if (response['success']) {
							// if (localStorage.getItem('email')) {
							// 	this._router.navigateByUrl('/dashboard');
							// }
							this.successMsg = true;
						}
					},
					err => {
						console.log(err);
						this.successMsg = false;
				});
			}
  }

  onNewQuery() {
    this.successMsg = false;
    this.onInit()
  }

  viewFile(index: number, file, element): void {
    const dialogRef = this.dialog.open(PdfViewerModalComponent, {
      width: '800px',
      data: {
        file: element["raw_images"][index]
      }
    });
  }

  openResubmitToast() {
		this._sharedService.openSnackBar(Constants.status.resubmit);
	}

  openEnterPasswordDialog(): void {
    this.dialog.open(PasswordModalComponent, {
      data: {
        "type": "enterpassword",
        "templateId": this.templateId
      },
      disableClose: true
    });
  }
  onPhoneInputChange(value, key) {
		$('.numbersOnly').keyup(function () { 
			this.value = this.value.replace(/[^0-9()\-. ]/g,'');
		});
		this.formResponse[key] = new AsYouType('US').input(value);
		let templateIndex = this.template.findIndex((element) => element.key === key);
		this.template[templateIndex]["error"] = "";
		this.template[templateIndex]["value"] = this.formResponse[key];
	}

  onInputChange(key) {
		let templateIndex = this.template.findIndex((element) => element.key === key);
		this.template[templateIndex]['error'] = "";
	}

  onContactInputChange(key, type, value) {
		if (type === 'email') {
			this.formResponse[key]["email"] = value;
		} else {
			this.formResponse[key]["phone"] = new AsYouType('US').input(value);
			let templateIndex = this.template.findIndex((field) => field.key === key);
			this.template[templateIndex]["data"]["phone"] = this.formResponse[key]["phone"];
		}
		$('.numbersOnly').keyup(function () {
			this.value = this.value.replace(/[^0-9()\-. ]/g,'');
		});
	}

	onContactInputBlur(key, type) {
		if (type === 'email') {
			let email = this.formResponse[key]["email"];
			const re = /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-zA-Z]{2,4}$/;
			let valid = re.test(String(email).toLowerCase());
			if (!valid) {
				let index = this.template.findIndex((element) => element.key === key);
				this.template[index]["data"]["emailError"] = "Enter valid email address";
				// this.saveValidity = false;
			} else {
				let index = this.template.findIndex((element) => element.key === key);
				this.template[index]["data"]["emailError"] = "";
				// this.saveValidity = true;
			}
		} else {
			let index = this.template.findIndex((element) => element.key === key);
			try {
				let phone = parsePhoneNumber(this.formResponse[key]["phone"], "US");
				const re = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
				let nationalNumber = phone.formatNational();
				let valid = re.test(nationalNumber);
				if (!valid) {
					this.template[index]["data"]["phoneError"] = "Enter valid phone number";
					// this.saveValidity = false;
				} else {
					this.formResponse[key]["phone"] = phone.number;
					this.template[index]["data"]["phoneError"] = "";
					// this.saveValidity = true;
				}	
			} catch (error) {
				this.template[index]["data"]["phoneError"] = "Enter valid phone number";
			}
		}
	}

	onAddressInput(key, type, value) {
		let templateIndex = this.template.findIndex((element) => element.key === key);
		if(!this.formResponse[key] || this.formResponse[key] === undefined) {
			this.formResponse[key] = {}
		}
		if(type == "address") {
			this.formResponse[key]["address"] = value;
			this.template[templateIndex]["data"]['addressError'] = ""
		} else if(type == "city") {
			this.formResponse[key]["city"] = value;
			this.template[templateIndex]["data"]['cityError'] = ""
		} else if(type == "state") {
			this.formResponse[key]["state"] = value;
			this.template[templateIndex]["data"]['stateError'] = ""
		} else if(type == "zipcode") {
			this.formResponse[key]["zipcode"] = value;
			this.template[templateIndex]["data"]['zipcodeError'] = ""
		}

		$('.numbersOnly').keyup(function () { 
			this.value = this.value.replace(/[^0-9()\-. ]/g,'');
		});
	}

	onAddressBlur(key, type) {
		let templateIndex = this.template.findIndex((element) => element.key === key);
		if(!this.formResponse[key] || this.formResponse[key] === undefined) {
			this.formResponse[key] = {}
		}
		let value = this.formResponse[key][type];
		let zipCodeValidator = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
		if(type == "address" && ((!value || value.length == 0))) {
			this.template[templateIndex]["data"]['addressError'] = "Enter valid Street Address"
		} else if(type == "city" && ((!value || value.length == 0))) {
			this.template[templateIndex]["data"]['cityError'] = "Enter valid City name"
		} else if(type == "state" && ((!value || value.length == 0))) {
			this.template[templateIndex]["data"]['stateError'] = "Enter valid State name"
		} else if(type == "zipcode" && ((!value || value.length == 0) || !zipCodeValidator.test(value))) {
			this.template[templateIndex]["data"]['zipcodeError'] = "Enter valid Zip"
		}
	}
}
